module.exports = __webpack_public_path__ + "img/10-1.d34683d9.jpg";